import { select } from 'helpers/dom'

const selectors = {
  TOPBAR_ITEM_SELECTOR: '.js-topbar-item',
  ANIMATION_CLASS: 'animate-scrollY'
}

class TopbarMarquee extends HTMLElement {
  constructor() {
    super()

    const { topbarData = [], duration = 3000 } = window.topbarMarqueeSettings || {}

    this.topbarData = topbarData
    this.duration = duration
    this.topbarItemEl = select(selectors.TOPBAR_ITEM_SELECTOR, this)
    this.index = 0
  }

  connectedCallback() {
    if (this.topbarData.length === 0 || !this.topbarItemEl) return

    this.showNextMessage()
    this._intervalId = setInterval(() => this.showNextMessage(), this.duration)
  }

  disconnectedCallback() {
    if (this._intervalId) clearInterval(this._intervalId)
  }

  showNextMessage() {
    this.topbarItemEl.innerHTML = this.topbarData[this.index]
    this.index = (this.index + 1) % this.topbarData.length

    // Reset animation
    this.topbarItemEl.classList.remove(selectors.ANIMATION_CLASS)
    this.topbarItemEl.getBoundingClientRect()
    this.topbarItemEl.classList.add(selectors.ANIMATION_CLASS)
  }
}

customElements.define('topbar-marquee', TopbarMarquee)
